import { Box, IconButton, Toolbar, Typography, Link } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AppBar } from "./Appbar";
import { GlobalContext } from "../../../GlobalContext";
import MenuIcon from "@mui/icons-material/Menu";
import { Left } from "./Left";
import { Right } from "./Right";
import { Link as RouterLink } from "react-router-dom";

const Navbar = ({ view, right }) => {
	const location = useLocation();
	const { openLeft, openRight, handlerSideLeft, handlerSideRight } = useContext(GlobalContext);
	// Obtener el valor completo desde localStorage
	const rawSiteName = localStorage.getItem("siteName") || "Sitio Predeterminado";
	// Dividir el string en secciones usando ":" como separador
	const siteSegments = rawSiteName.split(":");
	// Si hay 3 o más secciones, se muestran las últimas 3 con "..." delante;
	// en caso contrario, se muestran todas reemplazando los ":" por " / "
	const displaySiteName =
		siteSegments.length >= 3 ? `... ${siteSegments.slice(-3).join(" / ")}` : siteSegments.join(" / ");
	useEffect(() => {
		if (location.pathname !== "/review") {
			handlerSideRight(false, location.pathname.replace("/", ""));
		}
	}, [location.pathname, handlerSideRight]);
	return (
		<>
			<Box sx={{ display: "flex" }}>
				<AppBar
					position="fixed"
					open={openLeft || openRight}
					left={openLeft ? 240 : 0}
					right={openRight ? 430 : 0}
					sx={{
						bgcolor: "background.default",
						borderBottom: "1px solid",
						borderColor: "divider",
					}}
				>
					<Toolbar
						sx={{
							color: (theme) => (theme.palette.mode === "dark" ? "#ffffff" : "#000000"),
						}}
					>
						<IconButton
							color="inherit"
							onClick={() => handlerSideLeft(true)}
							edge="start"
							sx={{
								marginRight: 5,
								...(openLeft && { display: "none" }),
							}}
						>
							<MenuIcon />
						</IconButton>
						<Typography
							noWrap
							component="div"
							sx={{
								width: "94vw",
								fontSize: "24px",
								fontWeight: 700,
								textTransform: "uppercase",
								textAlign: "left",
								color: "text.primary",
							}}
						>
							{view.title}
						</Typography>
						{/* Se reemplaza el botón por un link y se agrega el nombre del sitio por encima */}
						<Box
							sx={{
								display: "flex",

								alignItems: "center",
								justifyContent: "center",
								width: "30%",
							}}
						>
							<Link
								variant="overline"
								component={RouterLink}
								to="/site"
								underline="none"
								sx={{ cursor: "pointer", fontWeight: "bold" }}
							>
								{displaySiteName}
							</Link>
						</Box>
					</Toolbar>
				</AppBar>
				<Left />
				{right && <Right title={right.title} component={right.component} />}
			</Box>
			<Box
				sx={{
					marginTop: "64px",
					marginLeft: openLeft ? "240px" : "64px",
					marginRight: openRight ? "400px" : "0px",
					height: "calc(100% - 64px)",
					padding: "20px",
				}}
			>
				{view.component}
			</Box>
		</>
	);
};

export default Navbar;
